import ContentFilter from "@material-ui/icons/FilterList";
import React from "react";
import { TextInput, SelectInput } from 'react-admin';
import { Form } from "react-final-form";
import { Box, Button } from "@material-ui/core";
import DivisionSelectInput from "../component/DivisionSelectInput";

const FilterButton = ({ showFilter }) => (
    <Button
        size="small"
        color="primary"
        onClick={() => showFilter("main")}
        startIcon={<ContentFilter />}
    >
        Фільтр
    </Button>
);

const FilterForm = ({
                        displayedFilters,
                        filterValues,
                        setFilters,
                        hideFilter,
                        open
                    }) => {
    if (!displayedFilters.main) {
        return null;
    }

    const onSubmit = values => {
        if (Object.keys(values).length > 0) {
            setFilters(values);
        } else {
            hideFilter("main");
        }
    };

    const resetFilter = () => {
        setFilters({}, []);
    };

    return (
        <div>
            <Form onSubmit={onSubmit} initialValues={filterValues}>
                {({ handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                        <Box mt={2} />
                        <Box display="flex" alignItems="flex-end" mb={1}>
                            <Box component="span" mr={2}>
                                <SelectInput label="Статус" source="status"
                                    choices={[
                                        {id: 'APPROVED', name: 'Активні'},
                                        {id: 'DISMISSED', name: 'Звільнені'}
                                    ]}
                                />
                            </Box>
                            <Box component="span" mr={2}>
                                <DivisionSelectInput label="Аптека" source={"division_id"} allowEmpty={true} />
                            </Box>
                            <Box component="span" mr={2}>
                                <TextInput label="ІПН" source="tax_id" />
                            </Box>
                            <Box component="span" mr={2} mb={4.1}>
                                <Button variant="outlined" color="primary" type="submit">
                                    Показати
                                </Button>
                            </Box>
                            <Box component="span" mb={4.1}>
                                <Button variant="outlined" onClick={resetFilter}>
                                    Закрити
                                </Button>
                            </Box>
                        </Box>
                    </form>
                )}
            </Form>
        </div>
    );
};

const Filter = props => {
    return props.context === "button" ? (
        <FilterButton {...props} />
    ) : (
        <FilterForm {...props} />
    )
};

export default Filter;